import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { connect, ConnectedProps } from 'react-redux';
import {
  followAdvice,
  search,
  reportAdviceClicked,
  reportAdviceShown,
} from '../../state/actions';
import { buildUrlWithParameters } from '../../../utils/url-utils/urlUtils';
import { buildSearchUrl, getUpdatedStateFromAdvice } from '../../state/utils';
import { StateType } from '../../../state/state.types';

const mapState = ({ queryParams, results }: StateType) => ({
  adviceUrl: results.adviceAction
    ? buildUrlWithParameters(
        buildSearchUrl(
          getUpdatedStateFromAdvice(queryParams, results.adviceAction),
        ),
        {
          source: 'search-advice',
        },
      )
    : '',
});

const mapDispatch = (dispatch: ThunkDispatch<StateType, {}, AnyAction>) => ({
  onFollowAdvice() {
    dispatch(followAdvice());
    dispatch(search({ reason: 'advice' }));
  },
  onAdviceClicked() {
    dispatch(reportAdviceClicked());
  },
  reportAdviceShown() {
    dispatch(reportAdviceShown());
  },
});

export const Connect = connect(mapState, mapDispatch);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
